module.exports = new Promise((resolve, reject) => {
    const url = (window.__ENV__?.['VUE_APP_VIDEO'] || '') + '/js/remoteEntry.js';
    console.log(url);
    const script = document.createElement('script');
    script.src = url;
    script.type = 'text/javascript';
    script.async = true;

    script.onload = () => {
      const container = window['videoApp'];
      if (!container) {
        return reject(new Error('Remote container videoApp not found on window after loading ' + url));
      }

      const proxy = {
        get: (request) => container.get(request),
        init: (arg) => {
          try { return container.init(arg); } catch (e) {}
        }
      };

      resolve(proxy);
    };

    script.onerror = () => reject(new Error('Failed to load ' + url));

    document.head.appendChild(script);
  });